export interface Toption {
    value: string,
    label: string,
    data?: any
}

export const initialOption: Toption = {
    value: "",
    label: "",
}

